import { useUser } from "../context/UserContext";
import "./Settings.css";

export default function Settings() {
  const { user } = useUser();

  return (
    <div className="settings-page">
      <h1>Account Settings</h1>

      <div className="settings-section">
        <h2>User Info</h2>
        <div className="setting-item">
          <label>Name</label>
          <span>{user?.displayName || "—"}</span>
        </div>
        <div className="setting-item">
          <label>Email</label>
          <span>{user?.email || "—"}</span>
        </div>
        <p className="setting-description">
            We use Google only for authentication. Your personal data is never stored, shared, or sold.
        </p>

      </div>

      <div className="settings-section disabled-section">
        <h2>
          Scoring Profile <span className="coming-soon-badge">Coming Soon</span>
        </h2>
        <div className="setting-item">
          <label>Choose a Profile</label>
          <select disabled defaultValue="balanced">
            <option value="balanced">Balanced (Default)</option>
            <option value="hype-hunter">Hype Hunter</option>
            <option value="underdog-sniper">Underdog Sniper</option>
            <option value="conservative">Conservative</option>
          </select>
        </div>
        <p className="setting-description">
          Your scoring profile customizes how HypeScore evaluates teams. Adjusts weight of hype signals, win streaks, injuries, and more.
        </p>
      </div>

      <div className="settings-section disabled-section">
        <h2>
          Email Alerts <span className="coming-soon-badge">Coming Soon</span>
        </h2>
        <div className="setting-item">
          <label>
            <input type="checkbox" disabled />
            Notify me when clutch score &gt; 90
          </label>
        </div>
        <div className="setting-item">
          <label>
            <input type="checkbox" disabled />
            Alert me when an underdog outperforms Vegas odds
          </label>
        </div>
        <div className="setting-item">
          <label>
            <input type="checkbox" />
            Weekly hype summary digest
          </label>
        </div>
        <p className="setting-description">
          Alerts are only sent while you're opted-in and authenticated. More
          options coming soon.
        </p>
      </div>
    </div>
  );
}
